export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const USER_INFO = "USER_INFO";
export const UNIT_LESSON = "UNIT_LESSON";